// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__308NI","Blue":"Status_Blue__3S4cU","Yellow":"Status_Yellow__CKHjE","Orange":"Status_Orange__2I-SU","Green":"Status_Green__mCBL1","Red":"Status_Red__3J0xp"};